module.exports = __webpack_public_path__ + "static/media/wallet.11cd7389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallet.png
// module id = 36
// module chunks = 0